import { I18n } from 'i18n-js'

import nl from './translations/nl.json'

const i18n = new I18n()

i18n.translations = { nl }
i18n.locale = 'nl'

export default i18n
